import React from 'react';
import { CheckIcon } from 'lucide-react';
import { images, reasons } from '../data/site';
import { SectionHeading } from './SectionHeading';
export function WhyChooseUs() {
  return <section id="why-us" className="relative w-full overflow-hidden bg-navy" data-id="element-196" data-mp="q6293q1yobxr">
      <img src={images.office} alt="" className="absolute inset-0 h-full w-full object-cover opacity-15" aria-hidden="true" data-id="element-197" data-mp="q3zlfcoa6uw7" />
      <div className="relative mx-auto max-w-7xl px-6 py-20 lg:py-24" data-id="element-198" data-mp="g6uz9cufqzfe">
        <SectionHeading eyebrow="Why Guernsey Cleaning?" title="Why Choose Us" tone="dark" data-id="element-199" data-mp="l6zfr2vcfu5m" />

        <ul className="mt-14 grid gap-8 sm:grid-cols-2 lg:grid-cols-3" data-id="element-200" data-mp="78ixceo4cf7n">
          {reasons.map(reason => <li key={reason.title} className="flex gap-4" data-id="element-201" data-mp="b8te8mdg8q1a">
              <span className="mt-1 flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-gold" data-id="element-202" data-mp="21kplsf60wshw">
                <CheckIcon className="h-4 w-4 text-white" aria-hidden="true" data-id="element-203" data-mp="25lj66yk9bp61" />
              </span>
              <div data-id="element-204" data-mp="1ndlpobb0oet7">
                <h3 className="font-display text-base font-extrabold uppercase tracking-wide text-white" data-id="element-205" data-mp="1ncu29nrkpne0">
                  {reason.title}
                </h3>
                <p className="mt-2 text-[15px] leading-relaxed text-white/70" data-id="element-206" data-mp="1x4q1j25ebjjt">
                  {reason.description}
                </p>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}